import ServiceOneIcon from './ServiceOneIcon';
import VehiclePlate from './VehiclePlate';

const displayName = customer =>
  [customer?.firstName, customer?.lastName].filter(Boolean).join(' ') || 'مشتری بدون نام';

export default function CustomerVehicleResult({ customer, vehicle, onSelect, approximate }) {
  return <button className={`service-one-search__result service-one-search__result--vehicle${approximate ? ' is-approximate' : ''}`} type="button" onClick={() => onSelect(customer, vehicle)}>
    <span className="service-one-search__avatar">{(customer.firstName || 'م')[0]}</span>
    <span className="service-one-search__person"><b>{displayName(customer)}</b><small dir="ltr">{customer.phone}</small></span>
    <ServiceOneIcon name="chevron" />
    <span className="service-one-search__found-car">
      <span><ServiceOneIcon name="car" /></span>
      <b>{vehicle.title || vehicle.brand || 'خودرو'}</b>
      <VehiclePlate vehicle={vehicle} variant="result" />
    </span>
    {approximate && <small className="service-one-search__near-label">پلاک نزدیک</small>}
  </button>;
}
